import * as actionTypes from './actionTypes';
import { YearVehicleModel } from '@app/src/views/StepOne/form/models/yearVehicle';

interface State {
  data: YearVehicleModel[];
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: [],
  isFetching: false,
  error: false
}

export const yearVehicle = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_VEHICLE_YEAR_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_VEHICLE_YEAR_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_VEHICLE_YEAR_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    default:
      return state;
  }
}
